var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripledots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2048_14733)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 34,
    rx: 8,
    fill: "#79A7EC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 32,
    rx: 7,
    stroke: "#79A7EC",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62 24.1C9.08667 24.1 8.66 23.94 8.34 23.62C8.03333 23.3 7.88 22.8867 7.88 22.38C7.88 21.8867 8.03333 21.4867 8.34 21.18C8.66 20.86 9.08667 20.7 9.62 20.7C10.1533 20.7 10.5667 20.86 10.86 21.18C11.1667 21.4867 11.32 21.8867 11.32 22.38C11.32 22.8867 11.1667 23.3 10.86 23.62C10.5667 23.94 10.1533 24.1 9.62 24.1ZM14.8153 24.1C14.282 24.1 13.8553 23.94 13.5353 23.62C13.2286 23.3 13.0753 22.8867 13.0753 22.38C13.0753 21.8867 13.2286 21.4867 13.5353 21.18C13.8553 20.86 14.282 20.7 14.8153 20.7C15.3486 20.7 15.762 20.86 16.0553 21.18C16.362 21.4867 16.5153 21.8867 16.5153 22.38C16.5153 22.8867 16.362 23.3 16.0553 23.62C15.762 23.94 15.3486 24.1 14.8153 24.1ZM20.0106 24.1C19.4773 24.1 19.0506 23.94 18.7306 23.62C18.424 23.3 18.2706 22.8867 18.2706 22.38C18.2706 21.8867 18.424 21.4867 18.7306 21.18C19.0506 20.86 19.4773 20.7 20.0106 20.7C20.544 20.7 20.9573 20.86 21.2506 21.18C21.5573 21.4867 21.7106 21.8867 21.7106 22.38C21.7106 22.8867 21.5573 23.3 21.2506 23.62C20.9573 23.94 20.544 24.1 20.0106 24.1Z",
    fill: "#F8FCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2048_14733",
    x: 0,
    y: 0,
    width: 30,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.455 0 0 0 0 0.725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_14733"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_14733",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripledots);
export default __webpack_public_path__ + "static/media/tripledots.30bd3a7d1f33817c454e544e1195b94b.svg";
export { ForwardRef as ReactComponent };